import { derived, get } from 'svelte/store';
import { useFetchClient } from '@foundatiofx/fetchclient';
import { toast } from 'svelte-sonner';
import { currentUser, logout } from '#api/auth.ts';

export const isImpersonating = derived(currentUser, ($user) => $user?.isImpersonating ?? false);

interface ImpersonationTokenResponse {
    token: string;
    portalUrl: string;
}

export type ImpersonationTarget = { obligorLoginId: number } | { obligorId: number };

export async function startImpersonation(target: ImpersonationTarget, obligationId?: number) {
    if (!get(currentUser)) return;

    // Open window synchronously (before await) to avoid popup blockers
    const popup = window.open('about:blank', '_blank');

    const result = await useFetchClient().postJSON<ImpersonationTokenResponse>('auth/impersonate', {
        ...target,
        obligationId
    });

    if (!result.ok || !result.data?.token || !result.data?.portalUrl) {
        popup?.close();
        toast.error('Failed to start impersonation session.');
        return;
    }

    if (!popup) {
        toast.error('Popup blocked. Please allow popups for this site.');
        return;
    }

    const url = new URL(result.data.portalUrl);
    if (window.location.port) {
        url.port = window.location.port;
    }
    url.protocol = window.location.protocol;
    url.pathname = '/impersonate';
    url.searchParams.set('token', result.data.token);
    popup.location.href = url.toString();
}

export async function endImpersonation() {
    try {
        await useFetchClient().postJSON('auth/impersonate/end', {});
    } finally {
        await logout();
        window.close();
    }
}
